module.exports = "13.4.9";



//////////////////
// WEBPACK FOOTER
// ./~/tone/Tone/version.js
// module id = 430
// module chunks = 0